import React from 'react'
import DriverLayout from '../../layouts/DriverLayout'
import Payment from '../../components/Payment'

const DriverPayment = () => {
  return (
    <DriverLayout>
    <Payment />
    </DriverLayout>
  )
}

export default DriverPayment
